module.exports = __webpack_public_path__ + "img/code.abf69336.jpg";